import ReportsPage from "components/Reports/Pages/Reports";

function DistributorReports() {
    return (
        <>
            <ReportsPage userType={4} />
        </>
    )
}

export default DistributorReports;
